import { HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";

export function isBlobError(err: any) {
  return (
    err instanceof HttpErrorResponse &&
    err.error instanceof Blob &&
    err.error.type === "application/json"
  );
}

export function parseErrorBlob(err: HttpErrorResponse): Observable<any> {
  const reader: FileReader = new FileReader();
  const obs = new Observable((observer: any) => {
    reader.onloadend = (e) => {
      observer.error(
        new HttpErrorResponse({
          error: JSON.parse(reader.result as string)
        })
      );
      observer.complete();
    };
  });
  reader.readAsText(err.error);
  return obs;
}
